const firebaseConfig = {

  apiKey: "AIzaSyDKwBkQJHxAO5n8hfdrssd3-zv8iqmrh0Y",

  authDomain: "steve-corry.firebaseapp.com",

  databaseURL: "https://steve-corry-default-rtdb.firebaseio.com",

  projectId: "steve-corry",

  storageBucket: "steve-corry.appspot.com",

  messagingSenderId: "597600975509",

  appId: "1:597600975509:web:7af53196c67751da55b99c",

  measurementId: "G-C6T67TEBKB"

};
export const environment = {
  production: false,
  firebase: firebaseConfig
};